import { render, staticRenderFns } from "./NavbarProfessor.vue?vue&type=template&id=afca2bbc&scoped=true"
import script from "./NavbarProfessor.vue?vue&type=script&lang=js"
export * from "./NavbarProfessor.vue?vue&type=script&lang=js"
import style0 from "./NavbarProfessor.vue?vue&type=style&index=0&id=afca2bbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afca2bbc",
  null
  
)

export default component.exports